<template>
  <attribution platform="ios" />
</template>
<script>
import Attribution from '@/modules/attribution/pages/AttributionFormPage'

export default {
  name: 'AttributionIos',

  components: { Attribution }
}
</script>



// WEBPACK FOOTER //
// src/modules/attribution/pages/AttributionIos.vue